import React from "react";

const Email = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero" {...props}>
          <g>
            <path
              d="M18.445 3.168c.46-.306 1.08-.182 1.387.277.285.427.198.993-.184 1.317l-.093.07-7.89 5.26c-.95.633-2.168.67-3.148.112l-.181-.112-7.89-5.26c-.46-.306-.584-.927-.278-1.387.285-.426.84-.564 1.286-.336l.1.059 7.891 5.26c.299.2.678.222.994.067l.116-.067 7.89-5.26z"
              transform="translate(2 4)"
            />
            <path
              d="M17 0H3C1.343 0 0 1.343 0 3v10c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3V3c0-1.657-1.343-3-3-3zM3 2h14c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1z"
              transform="translate(2 4)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Email;
